var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-product-swatch.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/core-product-swatch.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("productUrl")) {
var t_4 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_4);
if(t_1.hasOwnProperty("imageUrl")) {
var t_5 = t_1.imageUrl;
} else {
cb(new Error("cannot import 'imageUrl'")); return;
}
context.setVariable("imageUrl", t_5);
var t_6;
t_6 = (runtime.contextOrFrameLookup(context, frame, "tile")?runtime.contextOrFrameLookup(context, frame, "tile"):runtime.contextOrFrameLookup(context, frame, "product"));
frame.set("tileOrProduct", t_6, true);
if(frame.topLevel) {
context.setVariable("tileOrProduct", t_6);
}
if(frame.topLevel) {
context.addExport("tileOrProduct", t_6);
}
output += "<a\n\t";
output += runtime.suppressValue((lineno = 3, colno = 4, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","color click",(lineno = 3, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["tileOrProduct.product.displayName"])) + "" + " | " + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"displayName")])), env.opts.autoescape);
output += "\n\thref=\"";
output += runtime.suppressValue((lineno = 4, colno = 18, runtime.callWrap(t_4, "productUrl", context, [runtime.contextOrFrameLookup(context, frame, "productSlug"),"color=" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"code")])), env.opts.autoescape);
output += "\"\n\taria-label=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"displayName"), env.opts.autoescape);
output += "\"\n\tclass=\"o-list-swatches__a";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "selectedClass"),""), env.opts.autoescape);
output += " js-swatch-link-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "source"), env.opts.autoescape);
output += " has-mouse-click-focus-disabled\" \n\ttitle=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"displayName"), env.opts.autoescape);
output += "\"\n\tdata-color-code=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"code"), env.opts.autoescape);
output += "\"\n\tdata-view-code=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "viewCode"), env.opts.autoescape);
output += "\"\n\tdata-alt-view-code=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "hoverViewCode"), env.opts.autoescape);
output += "\"\n\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"videos") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"videos"))) {
output += " data-has-video";
;
}
output += "\n\trel=\"nofollow\"\n\t>\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"swatchUrl")) {
output += "<img title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"displayName"), env.opts.autoescape);
output += "\" class=\"o-list-swatches__swatch\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"swatchUrl"), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"displayName"), env.opts.autoescape);
output += "\" data-qa-swatch=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"code"), env.opts.autoescape);
output += "\" data-qa-swatch-image />";
;
}
else {
output += "<span class=\"o-list-swatches__swatch\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"hexColor")) {
output += "style=\"background-color:";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"hexColor"), env.opts.autoescape);
output += "\"";
;
}
output += " data-qa-swatch=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color")),"code"), env.opts.autoescape);
output += "\" data-qa-swatch-image></span>";
;
}
output += "</a>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-product-swatch.j2"] , dependencies)